<template>
    <div :class="{ visible }" class="flash sm:inline-block">
        <c-alert :color="color" class="mb-0 flex items-start justify-between gap-4 sm:inline-flex sm:items-center">
            <div>
                <render-content v-if="content != null" :node="content" />
            </div>
            <a v-if="isSticky" class="flash-close btn btn-icon text-success-emphasis" href="#" @click.prevent="visible = false">
                <icon name="cil-x-circle" />
            </a>
        </c-alert>
    </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, defineComponent } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { eventBus, events } from '@/eventBus.js';
import { renderNode, parseLinksFromString } from '@/Utils/flashContent.ts';

const visible = ref(false);
const timeoutId = ref(null);
const content = ref(null);
const isSticky = ref(false);
const type = ref('success');

const color = computed(() => (type.value === 'success' ? 'success' : 'danger'));

const page = usePage();
const flash = computed(() => {
    const props = page?.props?.value ?? page?.props ?? {};
    return props?.flash ?? null;
});

const RenderContent = defineComponent({
    name: 'RenderContent',
    props: {
        node: {
            type: [String, Number, Object, Array],
            default: null,
        },
    },
    setup(props) {
        return () => renderNode(props.node);
    },
});

function showFlashMessage(data) {
    type.value = data.error ? 'danger' : 'success';
    const message = data.message || data.error;
    if (typeof message === 'string') {
        const parsed = parseLinksFromString(message);
        content.value = parsed ?? message ?? '';
    } else {
        content.value = message ?? '';
    }
    isSticky.value = data.isSticky || false;
    visible.value = !!(message && (typeof message === 'string' ? message.length > 0 : true));

    if (timeoutId.value) {
        clearTimeout(timeoutId.value);
        timeoutId.value = null;
    }

    if (!isSticky.value) {
        timeoutId.value = setTimeout(() => {
            visible.value = false;
        }, 5000);
    }
}

watch(
    flash,
    (data) => {
        if (data) {
            showFlashMessage(data);
        }
    },
    { immediate: true, deep: true },
);

const onPresentFlashMessage = (data) => {
    showFlashMessage({
        message: data.payload.message,
        error: data.payload.status === 'error' ? data.payload.message : data.payload.error,
        isSticky: data.payload.isSticky,
    });
};

onMounted(() => {
    eventBus.$on?.(events.presentFlashMessage, onPresentFlashMessage);
});

onBeforeUnmount(() => {
    eventBus.$off?.(events.presentFlashMessage, onPresentFlashMessage);
});
</script>
